import React, { createContext, useState, useContext, useEffect } from 'react';
import apiService from '../services/apiService';
import {getAllAppRoles} from "../config/roles";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isUnassigned, setIsUnassigned] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        apiService.get('/api/user/me')
            .then(userData => {
                setUser(userData);

                const appRoles = getAllAppRoles();
                const userAppRoles = userData.roles?.filter(role => appRoles.includes(role));

                setIsUnassigned(userAppRoles.length === 0);
            })
            .catch(() => {
                setUser(null);
                setIsUnassigned(false);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const value = {
        user,
        isLoading,
        isUnassigned,
        hasRole: (role) => user?.roles?.includes(role) ?? false,
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};